import { isClient } from '@vueuse/core'

export const isFirefox = (): boolean =>
  isClient && /firefox/i.test(window.navigator.userAgent)

/**
 * Check if value is window object
 */
export const isWindow = (val: unknown): val is Window => {
  return typeof window !== 'undefined' && val === window
}
